import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'primevue/resources/themes/saga-blue/theme.css'       //tema
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeflex/primeflex.css'                             //libreria de estilos
import 'primeicons/primeicons.css'                           //iconos
import FontAwesomeIcon from "./assets/fontawesome-icons";
import './assets/styles/layout.scss'                         //estilos (sass)

import PrimeVue from 'primevue/config'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Divider from 'primevue/divider'
import Button from 'primevue/button'
import Password from 'primevue/password';
import Dropdown from 'primevue/dropdown'
import Message from 'primevue/message'
import InputMask from 'primevue/inputmask';
import InputText from 'primevue/inputtext'
import Avatar from 'primevue/avatar';

import Calendar from 'primevue/calendar'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Fieldset from 'primevue/fieldset'
import Skeleton from 'primevue/skeleton'
import SplitButton from 'primevue/splitbutton'
import Tooltip from 'primevue/tooltip'

const app = createApp(App)
    .use(PrimeVue,
        {
            ripple: true,
            csp: {
                nonce: 'XGgwSTSvSsAlcY9rdYQIWg=='
            },
            inputStyle: 'outlined',
            locale: {
                choose: 'Seleccionar',
                upload: 'Subir',
                cancel: 'Cancelar',
                firstDayOfWeek: 0,
                dayNames: [
                    "Domingo",
                    "Lunes",
                    "Martes",
                    "Miércoles",
                    "Jueves",
                    "Viernes",
                    "Sábado"
                ],
                dayNamesShort: [
                    "Dom",
                    "Lun",
                    "Mar",
                    "Mié",
                    "Jue",
                    "Vie",
                    "Sáb"
                ],
                dayNamesMin: [
                    "D",
                    "L",
                    "M",
                    "M",
                    "J",
                    "V",
                    "S"
                ],
                monthNames: [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre"
                ],
                monthNamesShort: [
                    "Ene",
                    "Feb",
                    "Mar",
                    "Abr",
                    "May",
                    "Jun",
                    "Jul",
                    "Ago",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dic"
                ],
                today: "Hoy"
            }
        }) //embellecedor
    .use(router)
.component("fa", FontAwesomeIcon)
.use(ToastService)
.component('Toast', Toast)
.component('ToastService',ToastService)
.component('Divider', Divider)
.component('Button', Button)
.component('Password', Password)
.component('Dropdown', Dropdown)
.component('Message', Message)
.component('InputMask', InputMask)
.component('InputText', InputText)
.component('Avatar', Avatar)

.component('Calendar', Calendar)
.component('Column', Column)
.component('DataTable', DataTable)
.component('Dialog', Dialog)
.component('Fieldset', Fieldset)
.component('Skeleton', Skeleton)
.component('SplitButton', SplitButton)

.directive('tooltip', Tooltip)

app.mount('#app')




